<template>
  <div class="common-wrapper" :class="wrapperClass">
    <div class="sectionTitle">
      <WaveTitle :title="title" :subhead="subhead"></WaveTitle>
    </div>
    <div class="common-content">
      <img class="prodImage" :src="productImage" :alt="title" />
      <div class="iconRow" :style="iconRowStyle">
        <IconRowItem v-for="(item, index) in iconData" :key="index" :item="item" />
      </div>
      <div class="bottom">
        <span @click="viewDetails">查看详情</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconRowItem from '@/components/IconRowItem.vue';
import WaveTitle from '@/components/WaveTitle.vue';

export default {
  name: 'ProductSection',
  components: {
    WaveTitle,
    IconRowItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subhead: {
      type: String,
      required: true,
    },
    productImage: {
      type: String,
      required: true,
    },
    iconData: {
      type: Array,
      required: true,
      default: () => [],
    },
    detailType: {
      type: String,
      required: true,
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    iconColumns: {
        type: Number,
        default: 5
    }
  },
  computed: {
    iconRowStyle() {
        return {
            display: 'grid',
            gridTemplateColumns: `repeat(${this.iconColumns}, 1fr)`,
            alignItems: 'start',
            justifyItems: 'center',
            width: '100%'
        };
    }
  },
  methods: {
    viewDetails() {
      this.$emit('view-details', this.detailType);
    },
  },
};
</script>

<style lang="less" scoped>
.common-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 96px 0;
  row-gap: 96px;
}

.common-content {
  width: 75%;
  display: flex;
  flex-direction: column;
  row-gap: 60px;
  align-items: center;

  .prodImage {
    width: 100%;
    max-width: 1536px;
  }

  .bottom {
    text-align: center;
    span {
      font-size: 18px;
      font-weight: normal;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0em;
      color: #429AF8;
      cursor: pointer;
    }
  }
}
</style> 